<!--  -->
<template>
  <div class="clientview">
    <div class="tabselecr_box">
      <div style="display:flex;align-items:flex-end">
        <!-- <el-input v-model="query.area" clearable style="width:400px;margin-right:10px" placeholder="请输入区域" /> -->
        <el-select v-model="query.area" style="margin-right:10px;width: 230px;" placeholder="请选择区域">
          <el-option
            v-for="item in areaarr"
            :key="item.value"
            :label="item.area"
            :value="item.value"
          />
        </el-select>
        <el-select v-model="query.up_plus" style="width: 230px;" placeholder="是否由创+">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input v-model="query.ip" placeholder="请输入ip" style="margin: 0 10px;width: 230px;" />
        <el-input v-model="query.client_host" placeholder="请输入设备编号" style="margin-right: 10px;width: 230px;" />
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
        <!-- <div style="width: 280px;">
          <span style="margin:0 10px">总绑定数:</span>
          <span>{{ allBindCount }}</span>
        </div> -->
        <el-tag type="success" style="margin-left:10px">总绑定数：{{ allBindCount }}</el-tag>
      </div>
    </div>
    <div>
      <div class="tipr">*优先选择绑定个数少的客户端,同一主体尽量绑定在同一客户端</div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="area_str"
        label="区域"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.area_str }}</span>
          <i v-if="client_ip===scope.row.ip" class="el-icon-info" />
        </template>
      </el-table-column>
      <el-table-column
        prop="ip"
        label="IP"
        width="400"
        align="center"
      />
      <el-table-column
        prop="client_host"
        label="客户端地址"
        width="400"
        align="center"
      />
      <el-table-column
        prop="up_plus"
        label="是否由创+"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.up_plus == 1 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        label="版本"
        width="130"
        align="center"
      />
      <el-table-column
        prop="max_bind"
        label="绑定上限"
        width="130"
        align="center"
      />
      <el-table-column
        prop="bind_count"
        label="已绑定个数"
        width="130"
        align="center"
      />
      <el-table-column
        prop="client_host"
        label="操作"
        align="center"
        fixed="right"
        width="160"
      >
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="choose(scope.row)">选择</el-button>
          <el-button v-if="client_ip===scope.row.ip" style="margin: 8px;" type="primary" size="mini" @click="unbinddata(scope.row)">解绑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { clientindex, clientareaList } from '@/api/officialaccount.js'
export default {
  name: 'Clientlist',
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        area: '',
        ip: '',
        up_plus: '',
        client_host: ''
      },
      tableData: [],
      total: null,
      loading: false,
      clientdiavieser: false,
      areaarr: [],
      employee_no: null,
      client_ip: '',
      allBindCount: null,
      options: [{
        value: 1,
        label: '否'
      }, {
        value: 2,
        label: '是'
      }]
    }
  },
  created() {
    // this.list()
    // this.arealist()
  },
  mounted() {

  },
  activated() {
    // this.list()
  },
  methods: {
    unbinddata(row) {
      this.$emit('undind', row.client_host, this.employee_no)
    },
    async send(item) {
      this.client_ips = item.client_ip
      await this.list()
      await this.arealist()
      this.tableData.filter(items => {
        if (items.ip === item.client_ip) {
          this.client_ip = item.client_ip
        }
      })
      this.employee_no = item.employee_no
    },
    async list() {
      this.loading = true
      const data = await clientindex(this.query)
      this.tableData = data.data.list
      this.allBindCount = data.data.allBindCount
      this.total = data.data.total
      this.loading = false
      console.log('data----', this.tableData, this.client_ip, '0--0')
    },
    async arealist() {
      const data = await clientareaList()
      this.areaarr = data.data
    },
    getdata() {
      this.tableData.filter(items => {
        // console.log(item, item.ip, 'this.tableData')
        if (items.ip === this.client_ips) {
          this.client_ip = this.client_ips
        }
      })
    },
    // 分页
    async  fetchPageSize(e) {
      this.query.page_size = e
      await this.list()
      this.getdata()
    },
    async fetchCurrentPage(e) {
      this.query.page = e
      await this.list()
      this.getdata()
    },
    async searchclick() {
      this.query.page = 1
      await this.list()
      this.getdata()
    },
    async  rechargeclick() {
      this.query.page = 1
      this.query.area = ''
      this.query.ip = ''
      this.query.client_host = ''
      this.query.up_plus = ''
      await this.list()
      this.getdata()
    },
    add(type, item) {
      this.clientdiavieser = true
      if (type === 1) {
        this.$nextTick(() => {
          this.$refs.clientdialogview.send(type)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.clientdialogview.send(type, item)
        })
      }
    },
    choose(item) {
      this.$emit('callback', item, this.employee_no)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.clientview{
  /* padding: 30px; */
}
.tabselecr_box{
  margin-bottom: 20px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.tipr{
  font-size: 17px;
  color: red;
  margin-bottom:10px
}
.el-icon-info{
  margin-left: 5px;
  color: #ff0000;
}
</style>
